











































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, PropSync, Watch } from 'vue-property-decorator';
import FormNavigationButtons from '@/components/tickets/tickets-form/common/FormNavigationButtons.vue';
import * as rules from '@/modules/shared/shared/domain/rules';
import { NetworkSecurityInternetGeneralInformationData } from '@/modules/tickets/requirement/network-security-internet/domain/network-security-internet-general-information';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    name: 'network-security-internet-general-information',
    components: { PhoneField, FormNavigationButtons },
})
export default class NetworkSecurityInternetGeneralInformation extends Vue {
    $refs!: {
        form: any;
    };

    private isFormValid: boolean = true;

    private rules: any = rules;

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    @PropSync('valuesOfForm', { required: true })
    formValues!: {
        generalInformation: NetworkSecurityInternetGeneralInformationData;
        categoriesTypings: Typing[];
    };

    get requireDescriptionField() {
        let r = true;
        if (this.formValues.generalInformation.subject) {
            if (this.formValues.generalInformation.subject.name.toLowerCase().includes('otro')) {
                r = this.formValues.generalInformation.description
                    ? this.formValues.generalInformation.description.length > 0
                    : false;
            }
        }
        return r || 'Se requiere detallar el asunto del ticket';
    }
}
